import React from "react";
import { useAccount } from "../contexts/AccountContext";

export default function AccountIndicator({ className = "", variant = "default" }) {
  const { selectedAccount, loading } = useAccount();

  if (loading) {
    if (variant === "compact") {
      return (
        <div className={`flex items-center gap-1.5 px-2 py-1.5 bg-gray-50 rounded-md ${className}`}>
          <div className="w-1.5 h-1.5 rounded-full bg-gray-300 animate-pulse" />
          <div className="h-2.5 bg-gray-300 rounded animate-pulse w-12"></div>
        </div>
      );
    }
    return (
      <div className={`flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg ${className}`}>
        <div className="w-2 h-2 rounded-full bg-gray-300 animate-pulse" />
        <div className="h-3 bg-gray-300 rounded animate-pulse w-16"></div>
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <div className={`flex items-center gap-1.5 px-2 py-1.5 bg-green-50 border border-green-200 rounded-md ${className}`}>
        {/* Status Indicator */}
        <div className="w-1.5 h-1.5 rounded-full bg-green-500" />
        
        {/* Account Name - very compact */}
        <div className="text-xs font-medium text-gray-700 truncate max-w-[80px] sm:max-w-[100px]">
          {selectedAccount?.name || 'No Account'}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 px-3 py-2 bg-green-50 border border-green-200 rounded-lg ${className}`}>
      {/* Status Indicator */}
      <div className="w-2 h-2 rounded-full bg-green-500" />
      
      {/* Account Name */}
      <div className="text-sm font-medium text-gray-700 truncate max-w-[120px] md:max-w-[200px]">
        {selectedAccount?.name || 'No Account'}
      </div>
    </div>
  );
}
